/**
 * useVoiceSessions Hook
 * Fetches all active voice sessions for Digital Office sidebar
 */

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/services/api.client';
import type { VoiceSessionsResponse } from '@/types/voice-session.types';

export const useVoiceSessions = () => {
  return useQuery({
    queryKey: ['voice', 'sessions'],
    queryFn: async () => {
      const response = await apiClient.get<VoiceSessionsResponse>('/voice/sessions');
      return response.data;
    },
    refetchInterval: 5000,
    staleTime: 3000,
  });
};
